import { Injectable, Inject, InjectionToken, ErrorHandler } from '@angular/core';
import * as Rollbar from 'rollbar';
import { environment } from '../../environments/environment';

const rollbarConfig: Rollbar.Configuration = {
  accessToken: environment.rollbarToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.production ? 'production' : 'development',
  enabled: true,
  itemsPerMinute: 10, // Limit to 10 items/minute to avoid flooding
  maxItems: 20, // Max items per page load
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true
      }
    }
  }
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

export function rollbarFactory(): Rollbar {
  return new Rollbar(rollbarConfig);
}

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {}

  handleError(err: any): void {
    // Log to console
    console.error(err);

    // Send to Rollbar
    this.rollbar.error(err.originalError || err);
  }
}
